<template>
  <div class="coin_market">
    <p class="market">{{ $t('市场') }}</p>
    <div class="search_box">
      <Input
        :value="searchCoin"
        :placeholder="$t('搜索')"
        style="width: 210px"
        @input="handleSearch"
      >
        <SvgIcon name="shousuo" slot="prefix"></SvgIcon>
      </Input>
      <div class="reverse_box" @click="switchMoney()">
        <div class="reverse_img">
          <img class="full_img" :src="isDollar ? dollar : cny" alt="" />
        </div>
        <span :class="isDollar ? 'dollar_gray' : 'cny_blue'">CNY</span>
      </div>
    </div>

    <!-- tab 部分 -->
    <div class="tabs_box">
      <ul class="tabs">
        <li
          v-for="(val, key) in tabList"
          :key="key"
          :class="{ each_tab_active: currentTab === key }"
          class="each_tab"
          @click="switchTabs(key)"
        >
          <p class="tab_text">{{ val }}</p>
          <p class="tab_line"></p>
        </li>
      </ul>
    </div>
    <div class="tabpane_box">
      <div class="sort_box">
        <div
          class="left_sort"
          @click="
            handleClickSort({ type: 'SET_CONTROL_COIN', field: 'controlCoin' })
          "
        >
          <span>{{ $t('币种') }}</span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlCoin === 0
                ? noneActive
                : controlCoin === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
        <div
          class="middle_sort"
          @click="
            handleClickSort({
              type: 'SET_CONTROL_PRICE',
              field: 'controlPrice',
            })
          "
        >
          <span>
            {{ $t('最新价') }}<em v-if="!isDollar" class="uppercase">(CNY)</em>
          </span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlPrice === 0
                ? noneActive
                : controlPrice === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
        <div
          class="right_sort"
          @click="
            handleClickSort({
              type: 'SET_CONTROL_UPDOWN',
              field: 'controlUpDown',
            })
          "
        >
          <span>{{ $t('涨幅') }}</span>
          <img
            style="width: 10px; height: 14px"
            :src="
              controlUpDown === 0
                ? noneActive
                : controlUpDown === 1
                ? upActive
                : downActive
            "
            alt=""
          />
        </div>
      </div>
      <div
        v-loading="loading"
        :element-loading-background="
          currentSkin === 'black'
            ? 'rgba(23, 27, 43, 1)'
            : 'rgba(255, 255, 255, 1)'
        "
        class="coin_box"
      >
        <ul v-if="finalCoinList.length" class="coin_ul">
          <li
            v-for="(item, index) in finalCoinList"
            :key="index"
            :class="{
              active_coin_li: item.marketId === tradingPairId,
            }"
            class="each_coin_li"
            @click="handleCoin(item)"
          >
            <div class="coin_type">
              <div
                class="img_box"
                @click.stop="
                  isSignIn
                    ? handleOriginCollect(
                        item.marketId,
                        collectCoinObj[item.marketId]
                      )
                    : handleNativeCollect(item)
                "
              >
                <img
                  :src="
                    collectCoinObj[item.marketId]
                      ? collectionActive
                      : currentSkin === 'black'
                      ? collectionBlackNegative
                      : collectionWhiteNegative
                  "
                  alt=""
                />
              </div>
              <span>{{ item.market.toUpperCase().replace('_', '/') }}</span>
            </div>
            <span class="new_price">{{
              isDollar ? item.price : item.cny
            }}</span>
            <span
              :class="{
                up_green: Number(item.ratio) > 0,
                down_red: Number(item.ratio) < 0,
              }"
              class="up_down_num"
              >{{ item.ratio }}%</span
            >
          </li>
        </ul>
        <NoData
          v-else
          :sceneType="currentSkin === 'black' ? 'night' : 'day'"
        ></NoData>
      </div>
    </div>
  </div>
</template>
<script>
import { sendWSPush } from '@/utils/webSocket'
import collect from '@/mixin/collect'
import {
  SET_DOLLAREXHIBITION,
  SET_TRADING_PAIR_DATA,
} from '@/store/mutation-types'
import { mapState, mapGetters } from 'vuex'

export default {
  mixins: [collect],
  data() {
    return {
      searchCoin: '',
      dollar: require('./../../../../assets/images/qiehuangray.png'),
      cny: require('./../../../../assets/images/qiehuan.png'),
      currentTab: 'collectionList',
      collectionActive: require('./../../../../assets/images/zixuan-xingxing-yixuan-blue.png'),
      collectionBlackNegative: require('./../../../../assets/images/zixuan-xingxing-weixuan.png'),
      collectionWhiteNegative: require('./../../../../assets/images/whitePray.png'),
      noneActive: require('./../../../../assets/images/qiehuan1.png'),
      downActive: require('./../../../../assets/images/qiehuan2.png'),
      upActive: require('./../../../../assets/images/qiehuan3.png'),
      nonCustomizedCoinList: [],
    }
  },
  async created() {
    // this.isCreateMarket = true
    // 先获取用户收藏币种列表再获取市场币种数据
    if (this.isSignIn) {
      await this.$store.dispatch('market/setCollectionCoin')
    }

    // sendWSPush({ channel: 'public', language: 'zh' })

    // 从其他页面进来时，重新指定当前活跃的 tab
    // if (this.$route.params.tradingPair) {
    //   const tradingPair = this.$route.params.tradingPair
    //   const targetIndex = tradingPair.indexOf('_')
    //   const result = tradingPair.substr(targetIndex + 1)
    // }
  },
  computed: {
    ...mapGetters(['isSignIn', 'tradingPairId']),
    ...mapState({
      isDollar: (state) => state.transaction.dollarExhibition,
      controlCoin: (state) => state.transaction.controlCoin,
      controlPrice: (state) => state.transaction.controlPrice,
      controlUpDown: (state) => state.transaction.controlUpDown,
      currentSkin: (state) => state.transaction.currentSkin,
      quotes: (state) => state.transaction.quotes,
      marketTabs: (state) => state.transaction.marketTabs,
      collectCoinListLocal: (state) => state.market.collectCoinListLocal, // 用户本地收藏的币种列表（用来进行对比）
      collectCoinListOrigin: (state) => state.market.collectCoinListOrigin, // 用户远程收藏的币种列表（用来进行对比）
    }),
    tabList() {
      return {
        collectionList: this.$t('自选'),
        ...this.marketTabs.reduce((calc, item) => {
          calc[item] = item
          return calc
        }, {}),
      }
    },
    loading() {
      return !Object.keys(this.quotes).length
    },
    collectCoinList() {
      return this.isSignIn
        ? this.collectCoinListOrigin
        : this.collectCoinListLocal
    },
    collectCoinObj() {
      return this.collectCoinList.reduce((calc, item) => {
        calc[item.marketId] = true
        return calc
      }, {})
    },
    finalCoinList() {
      let coinList =
        this.currentTab === 'collectionList'
          ? this.collectCoinList
          : this.nonCustomizedCoinList

      coinList = coinList
        .map((item) => this.quotes[item.marketId])
        .filter(Boolean)

      if (this.searchCoin) {
        coinList = coinList.filter((item) =>
          item.market.toUpperCase().startsWith(this.searchCoin.toUpperCase())
        )
      }

      if (this.controlUpDown) {
        this.sortCoinList(coinList, this.controlUpDown === 1, 'ratio')
      }
      if (this.controlPrice) {
        const priceField = this.isDollar ? 'price' : 'cny'
        this.sortCoinList(coinList, this.controlPrice === 1, priceField)
      }
      if (this.controlCoin) {
        this.sortCoinList(
          coinList,
          this.controlCoin === 1,
          (coin) => coin.market.split('/')[0]
        )
      }

      return coinList
    },
  },
  watch: {
    // $route: {
    //   handler (newVal) {
    //     if (newVal.params.tradingPair) {
    //       const tradingPair = newVal.params.tradingPair.replace(/_/, '/')
    //       const coinId = newVal.params.coinId
    //       this.$store.commit(`transaction/${SET_TRADING_PAIR_ID}`, coinId)
    //       this.$store.commit(`transaction/${SET_TRADING_PAIR}`, tradingPair)
    //     }
    //   },
    //   immediate: true
    // },
  },
  methods: {
    compareStrings(str1, str2) {
      const minLength = Math.min(str1.length, str2.length)

      for (let i = 0; i < minLength; i++) {
        if (str1[i] < str2[i]) {
          return false
        } else if (str1[i] > str2[i]) {
          return true
        }
      }

      return str1.length - str2.length > 0
    },
    sortCoinList(arr, isAscending, fieldFn) {
      arr.sort((cur, next) => {
        if (isAscending) {
          if (typeof fieldFn === 'string') {
            return cur[fieldFn] - next[fieldFn]
          } else {
            return this.compareStrings(fieldFn(cur), fieldFn(next)) ? 1 : -1
          }
        } else {
          if (typeof fieldFn === 'string') {
            return next[fieldFn] - cur[fieldFn]
          } else {
            return this.compareStrings(fieldFn(cur), fieldFn(next)) ? -1 : 1
          }
        }
      })
    },
    // 处理点击排序
    handleClickSort(sortObj) {
      ;['SET_CONTROL_COIN', 'SET_CONTROL_PRICE', 'SET_CONTROL_UPDOWN'].forEach(
        (item) => {
          if (!sortObj) {
            this.$store.commit(`transaction/${item}`, 0)
          } else {
            const { type, field } = sortObj
            if (type === item) {
              let val = this[field]
              val = val < 2 ? ++val : 0
              this.$store.commit(`transaction/${item}`, val)
            } else {
              this.$store.commit(`transaction/${item}`, 0)
            }
          }
        }
      )
    },
    // 搜索币种
    handleSearch(val) {
      this.searchCoin = val
      this.handleClickSort()
    },
    switchMoney() {
      const saveIsDollar = !this.isDollar
      this.$store.commit(`transaction/${SET_DOLLAREXHIBITION}`, saveIsDollar)
    },
    switchTabs(name) {
      this.currentTab = name // 切换 tab
      if (name !== 'collectionList') {
        this.nonCustomizedCoinList = Object.keys(this.quotes).reduce(
          (calc, key) => {
            if (this.quotes[key].area.toUpperCase() === name) {
              calc.push(this.quotes[key])
            }
            return calc
          },
          []
        )
      }
    },
    // 点击列表中某一个币种
    handleCoin(item) {
      this.$store.commit(`transaction/${SET_TRADING_PAIR_DATA}`, item)
    },
  },
}
</script>
<style lang="less" scoped>
.coin_market {
  width: 320px;
  height: 100%;
  background: @contentBgColor1;

  .market {
    padding: 10px 20px;
    font-size: 16px;
    font-family: PingFangSC-Medium, 'PingFang SC';
    font-weight: 500;
    color: @textColor1;
    background-color: @titleBgColor1;
  }
  .search_box {
    margin: 20px 0px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .reverse_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .reverse_img {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
      // 动态改变字体颜色
      .dollar_gray {
        color: rgba(172, 180, 215, 1);
      }
      .cny_blue {
        color: rgba(66, 179, 250, 1);
      }
    }
  }
  .tabs_box {
    padding-left: 22px;
    .tabs {
      padding: 6px 0 5px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .each_tab {
        margin: 0 5px;
        padding: 0px 6px;
        cursor: pointer;
        .tab_text {
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: @textColor1;
          line-height: 20px;
          text-align: center;
        }
        .tab_line {
          width: 0;
          height: 4px;
          background: rgba(66, 179, 250, 1);
        }
      }
      // 动态设置市场 tab 样式
      .each_tab_active {
        .tab_text {
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, 'PingFang SC';
          font-weight: 500;
          line-height: 25px;
        }
        .tab_line {
          width: 100%;
        }
      }
      li:first-child {
        margin: 0 5px 0 0;
        padding: 0px 6px 0 0;
      }
    }
  }
  .tabpane_box {
    margin-top: 10px;
    height: calc(100% - 164px);
    position: relative;
    .sort_box {
      padding: 6px 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .left_sort,
      .middle_sort,
      .right_sort {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        span {
          margin-right: 2px;
          font-size: 12px;
          font-weight: 400;
          color: @textColor2;
          line-height: 18px;
        }
      }
      .middle_sort {
        position: absolute;
        right: 105px;
      }
    }
    .coin_box {
      margin-top: 4px;
      overflow-y: auto;
      height: calc(100% - 34px);
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, 0.3);
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(144, 147, 153, 0.5);
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }
      .coin_ul {
        .each_coin_li {
          // 布局要点
          padding: 5px 20px;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          .coin_type {
            width: 85px;
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-shrink: 0;
            .img_box {
              margin-right: 4px;
              width: 12px;
              height: 18px;
              line-height: 15px;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
          .new_price {
            display: inline-block;
            width: 106px;
            text-align: right;
            flex-shrink: 0;
          }
          .up_down_num {
            display: inline-block;
            width: 86px;
            text-align: right;
            flex-shrink: 0;
          }
          span {
            font-size: 14px;
            font-weight: 400;
            color: @textColor3;
            line-height: 20px;
          }
          // 动态改变字体颜色
          .up_green {
            color: rgba(65, 179, 126, 1);
          }
          .down_red {
            color: rgba(223, 52, 61, 1);
          }
        }
        // 每个币种鼠标移入背景颜色
        .each_coin_li:hover {
          background-color: @hoverBgColor;
        }
        // 当前币种高亮背景颜色
        .active_coin_li {
          background: @hoverBgColor;
        }
      }
    }
  }
}
</style>
